export default {
  guestRedirectPath: '/',
  memberRedirectPath: '/',
  rootUrl: '/'
};
